<script lang="ts">
  import { CostShare } from '../lib/cost-share';
  import { Format } from '../lib/format';
  import type { PeriodTotals } from '../lib/period-totals';

  interface Props {
    total: PeriodTotals;
  }

  let { total }: Props = $props();

  const gasto = $derived(
    CostShare.of([
      { label: 'entrada fria', value: total.split.inputCacheMiss },
      { label: 'cache hit', value: total.split.inputCacheHit },
      { label: 'saída', value: total.split.output },
    ]),
  );

  const saida = $derived(
    CostShare.of([
      { label: 'raciocínio', value: total.tokens.reasoning },
      { label: 'texto ao cliente', value: total.tokens.completion - total.tokens.reasoning },
    ]),
  );
</script>

<div class="totals">
  <div class="total-card primary">
    <span class="total-label">Total no período</span>
    <span class="total-value">{Format.brl(total.brl)}</span>
    <span class="total-sub mono">{Format.usd(total.usd)}</span>
  </div>
  <div class="total-card">
    <span class="total-label">Chamadas de IA</span>
    <span class="total-value">{Format.count(total.calls)}</span>
    <span class="total-sub mono">{total.clientCount} cliente(s)</span>
  </div>
  <div class="total-card">
    <span class="total-label">Cache hit</span>
    <span class="total-value">{Format.percent(total.tokens.cached, total.tokens.prompt)}</span>
    <span class="total-sub mono">{Format.count(total.tokens.prompt)} tok in</span>
  </div>
  <div class="total-card">
    <span class="total-label">Onde vai o gasto</span>
    <span class="total-value">{gasto.leader}</span>
    <span class="total-sub mono">{gasto.rest}</span>
  </div>
  <div class="total-card">
    <span class="total-label">Tokens saída</span>
    <span class="total-value">{saida.leader}</span>
    <span class="total-sub mono">{Format.count(total.tokens.completion)} tok · {saida.rest}</span>
  </div>
</div>

<style>
  .totals {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: var(--space-4);
  }
  .total-card {
    background: var(--bg-elevated);
    border: 1px solid var(--border-subtle);
    border-radius: var(--radius-md);
    padding: var(--space-4);
    display: flex;
    flex-direction: column;
    gap: var(--space-1);
  }
  .total-card.primary {
    border-color: var(--color-success);
  }
  .total-label {
    font-size: 12px;
    color: var(--text-tertiary);
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  .total-value {
    font-size: 26px;
    font-weight: 600;
    letter-spacing: -0.02em;
    color: var(--text-primary);
  }
  .total-sub {
    font-size: 12px;
    color: var(--text-secondary);
  }
</style>
